import React, { useState } from 'react';
import { OrderDetailsDTO } from '../../types/order';
import { useLanguage } from '@/context/LanguageContext';
import { getMeasurementLabel } from '@/utils/measurementTranslations';

interface MeasurementsCardProps {
  order: OrderDetailsDTO;
  onAttachMeasurement: () => void;
  onSwitchMeasurement: () => void;
}

const MeasurementsCard: React.FC<MeasurementsCardProps> = ({
  order,
  onAttachMeasurement,
  onSwitchMeasurement,
}) => {
  const { t } = useLanguage();
  const [expanded, setExpanded] = useState(false);
  
  // Check if measurementSet exists and has fields
  const hasMeasurementSet = order.measurementSet && order.measurementSet.fieldsPreview && order.measurementSet.fieldsPreview.length > 0;
  
  if (!hasMeasurementSet) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Measurements</h3>
        <div className="text-center py-8">
          <p className="text-gray-500 mb-4">No measurement set attached</p>
          <button
            onClick={onAttachMeasurement}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Attach Measurement Set
          </button>
        </div>
      </div>
    );
  }
  
  const { measurementSet } = order;
  const previewFields = expanded
    ? measurementSet.fieldsPreview
    : measurementSet.fieldsPreview.slice(0, 3);
  
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Measurements</h3>
        <button
          onClick={onSwitchMeasurement}
          className="text-sm text-blue-600 hover:text-blue-700"
        >
          Switch
        </button>
      </div>
      
      <div className="mb-4">
        <p className="text-sm font-medium text-gray-900">
          {measurementSet.name}
        </p>
        <p className="text-xs text-gray-500 mt-1">
          Last updated: {new Date(measurementSet.updatedAt).toLocaleDateString()}
        </p>
      </div>
      
      <div className="space-y-2">
        {previewFields.map((field) => (
          <div key={field.key} className="flex justify-between text-sm">
            <span className="text-gray-600">{getMeasurementLabel(field.key, t)}</span>
            <span className="font-medium text-gray-900">{field.value}"</span>
          </div>
        ))}
      </div>
      
      {measurementSet.fieldsPreview.length > 3 && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="mt-4 text-sm text-blue-600 hover:text-blue-700"
        >
          {expanded ? 'View less' : `View all (${measurementSet.fieldsPreview.length} fields)`}
        </button>
      )}
    </div>
  );
};

export default MeasurementsCard;

